import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../data/ColisContext';

export default function RequireAdmin({ children }) {
  const { user, authBooting } = useApp();
  const location = useLocation();

  const isAdmin = user?.is_admin === true || user?.is_admin === 1 || user?.is_admin === '1';

  if (authBooting) return null;

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
